module.exports = __webpack_public_path__ + "img/pic3.61756067.png";